import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center px-4 py-16 text-center sm:px-6">
      <p className="text-sm font-semibold uppercase tracking-wider text-brand-700">
        404
      </p>
      <h1 className="mt-2 text-4xl font-semibold tracking-tight text-ink-900 sm:text-5xl">
        We couldn't find that page.
      </h1>
      <p className="mt-4 max-w-lg text-ink-600">
        The link may be out of date. Head home or jump to features.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-gradient-to-br from-brand-600 to-violet-600 px-5 py-3 text-sm font-semibold text-white shadow-sm shadow-brand-600/20 transition hover:from-brand-700 hover:to-violet-700 hover:shadow-md"
        >
          Home
        </Link>
        <Link
          to="/features"
          className="rounded-md border border-ink-200 bg-white px-5 py-3 text-sm font-semibold text-ink-900 transition hover:bg-ink-100"
        >
          Features
        </Link>
      </div>
    </section>
  );
}
